import { PostApiCall, PutApiCall, PostApiCallCashier } from "./axiosSetup";

export const SIGN_IN = "/authorization/signin";
export const SIGN_UP = "/authorization/signup";
export const SIGN_OUT = "/authorization/signout";
export const RESET_PASSWORD = "/authorization/reset-password";
export const CHANGE_PASSWORD = "/authorization/change-password";

export const SignIn = async (data) => PostApiCall(SIGN_IN, data);
export const SignInCashier = async (data) => PostApiCallCashier(SIGN_IN, data);
export const SignUp = async (data) => PostApiCall(SIGN_UP, data);
export const SignUpCashier = async (data) => PostApiCallCashier(SIGN_UP, data);
export const SignOut = async (data) => PostApiCall(SIGN_OUT, data);
export const ResetPassword = async (data) => PutApiCall(RESET_PASSWORD, data);
export const ChnagePassword = async (data) => PutApiCall(CHANGE_PASSWORD, data);
